import React from "react";
import InstructionCard from "Components/instruction_card/InstructionCardMobile";
import Accordion from "components/accordion/Accordion";

const HowToClaimTicketMobile = ({ ...props }) => (
	<div className="how-to-claim-container">
		<Accordion
			id={props.accordionId}
			title={(
				<>
					<h3 className="how-to-claim-title">{props.firstTitle}&nbsp;<span>{props.secondTitle}</span></h3>
				</>
			)}
			isActive={props.isAccordionActive}
			toggleAccordion={props.toggleAccordion}
		>
			<p className="how-to-claim-subtitle">{props.subtitle}</p>

			<div className="instruction-card-container">
				{
					props.instructionCard.length > 0 && props.instructionCard.map((instruction) => (
						<InstructionCard
							key={instruction.id}
							isMobile={props.isMobile}
							id={instruction.id}
							img={instruction.img}
							content={instruction.content}
						/>
					))
				}
			</div>
		</Accordion>

		<style jsx>
			{`
        h3 {
          margin: 0;
          padding: 0;
        }

        .how-to-claim-container {
          font-family: 'Poppins', sans-serif;
          margin-top: ${props.marginTop}
          margin-bottom: ${props.marginBottom};
        }

        .how-to-claim-title {
          font-weight: 600;
          font-size: 14px;
          line-height: 22px;
          text-transform: capitalize;
          color: #000000;
          margin: 0;
          width: calc(100% - 30px);
        }

        .how-to-claim-subtitle {
          font-family: 'Roboto', sans-serif;
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 24px;
          color: #323942;
          margin: 0;
          margin-top: 8px;
        }

        .instruction-card-container {
          width: 100%;
          margin-top: 16px;
          text-align: center;
        }
      `}
		</style>
	</div>
);

export default HowToClaimTicketMobile;
